export function repositionItem<T>(items: T[], item: T, oldIndex: number, newIndex: number) {
    return oldIndex > newIndex ?
        [...items.slice(0, newIndex), item, ...items.slice(newIndex, oldIndex), ...items.slice(oldIndex + 1)]
        :
        [...items.slice(0, oldIndex), ...items.slice(oldIndex + 1, newIndex + 1), item, ...items.slice(newIndex + 1)]
}

export function isNullOrEmpty<T>(items: T[] | null) {
    return !items || items.length === 0
}